'use strict';

const searchForm = document.getElementById('name-header-search-area');
const searchOpen = document.getElementById('name-header-search-open-btn');
const searchClose = document.getElementById('name-header-search-close-btn');
const input = document.getElementById('q');

if (searchOpen) {
  searchOpen.addEventListener('click', () => {
    searchOpen.classList.add('state-hidden');
    searchForm.classList.add('state-active');
    searchClose.classList.remove('state-hidden');
    input.focus();
  });
}

if (searchClose) {
  searchClose.addEventListener('click', () => {
    searchOpen.classList.remove('state-hidden');
    searchForm.classList.remove('state-active');
    searchClose.classList.add('state-hidden');
  });
}

const body = document.body;
const menuOpen = document.getElementById('name-main-nemu-open-btn');
const menuClose = document.getElementById('name-main-nemu-close-btn');

if (menuOpen) {
  menuOpen.addEventListener('click', () => {
    body.classList.add('menu-is-active');
    menuOpen.classList.add('state-hidden');
    menuClose.classList.remove('state-hidden');
    mainMenu.classList.add('state-active');
    input.focus();
  });
}

if (menuClose) {
  menuClose.addEventListener('click', () => {
    body.classList.remove('menu-is-active');
    menuOpen.classList.remove('state-hidden');
    menuClose.classList.add('state-hidden');
    mainMenu.classList.remove('state-active');
  });
}